import * as React from 'react';
export const panelArrowRightSvg = React.forwardRef(
  function panelArrowRightSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M1.875 1A.875.875 0 0 0 1 1.875v12.25a.875.875 0 0 0 1.75 0V1.875A.875.875 0 0 0 1.875 1Zm6.899.867a.875.875 0 0 0-.03 1.237l3.837 4.021H5.875a.875.875 0 1 0 0 1.75h6.638L8.76 12.632a.875.875 0 1 0 1.238 1.236l5.247-5.25a.873.873 0 0 0 .014-1.222l-5.247-5.5a.875.875 0 0 0-1.237-.03Z',
      }),
    );
  },
);
panelArrowRightSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var panelArrowRight = {
  category: 'icon',
  colorable: true,
  name: 'panelArrowRight',
  svg: panelArrowRightSvg,
};
